import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { CalendarServiceInstance, addDays, displayStatus, formatLongDate, formatTimeRange, instancesForDay, serviceColour } from "./calendarUtils";

interface Props { weekStart: Date; instances: CalendarServiceInstance[]; onSelectDate: (date: Date) => void; onOpen: (instance: CalendarServiceInstance) => void; }

export default function CalendarListView({ weekStart, instances, onSelectDate, onOpen }: Props) {
  const days = Array.from({ length: 7 }, (_, index) => addDays(weekStart, index));
  const populated = days.filter((day) => instancesForDay(instances, day).length > 0);
  if (populated.length === 0) return <div className="calendar-empty"><strong>No services scheduled</strong><span>There are no scheduled services for this period.</span></div>;
  return (
    <div className="calendar-list">
      {populated.map((day) => (
        <section key={day.toISOString()}>
          <button type="button" className="calendar-list-date" onClick={() => onSelectDate(day)}>{formatLongDate(day)}</button>
          <div className="calendar-list-rows">
            {instancesForDay(instances, day).map((instance) => {
              const status = displayStatus(instance);
              return (
                <button type="button" key={instance.serviceInstanceId} className="calendar-list-row" style={{ ["--service-colour" as string]: serviceColour(instance) }} onClick={() => { onSelectDate(day); onOpen(instance); }}>
                  <span>{formatTimeRange(instance)}</span><strong>{instance.serviceName}</strong>
                  <span className="calendar-list-meta"><LocationOnOutlinedIcon />{instance.venue || "Venue not set"}</span>
                  <span className="calendar-list-meta"><GroupsOutlinedIcon />{instance.capacity != null ? `${instance.bookedCount ?? 0} / ${instance.capacity}` : "–"}</span>
                  <span className={`calendar-status calendar-status--${status.toLowerCase().replace(/\s+/g, "-")}`}>{status}</span><ChevronRightIcon />
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
